import { NavLink, useNavigate } from "react-router-dom";
import JobZImage from "../../../../common/jobz-img";
import { canRoute, candidate, empRoute, employer, publicUser } from "../../../../../globals/route-names";
import processLogin from "../../../../form-processing/login";
import { formType } from "../../../../../globals/constants";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import { useState } from "react";
import { jwtDecode } from "jwt-decode";
import { addDoc, collection, query, where, onSnapshot, getDocs, updateDoc } from "firebase/firestore";
import { db, auth } from "../../../../../globals/firebase";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";


function LoginPage() {

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSignUp, setIsSignUp] = useState(false);
    const [error, setError] = useState('');

    const handleEmailAuth = async (e) => {
        e.preventDefault();
        setError('');

        try {
            if (isSignUp) {
                // Sign Up
                const userCredential = await createUserWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;

                // Create user in Firestore
                const newUser = {
                    userid: user.uid,
                    name: email.split('@')[0], // Default name from email
                    email: email,
                    picture: "", // No picture initially
                    datainsert: Date.now(),
                    creditsprompts: 10,
                    creditsimages: 12
                };

                const myCollection = collection(db, 'wpm_users');
                await addDoc(myCollection, newUser).then(async (doc) => {
                     // Although we set userid above, sometimes we want the doc id to be the userid or store doc id. 
                     // The google login logic updates the doc with userid = doc.id. 
                     // But here user.uid is from Auth. Let's follow the google login pattern if we want consistency, 
                     // OR prefer user.uid from Auth as the key.
                     // The Google login logic:
                     // await addDoc(myCollection, user).then(async (doc) => { await updateDoc(doc, { userid: doc.id }); ... })
                     // It uses the Firestore Document ID as the userid.
                     // Let's stick to that pattern for consistency, although using Auth UID is often better.
                     // Wait, the Google logic:
                     // user.userid = doc.id
                     // So it ignores the google sub/id and uses firestore id.
                     
                     // Let's replicate that exactly.
                     
                     await updateDoc(doc, {
                        userid: doc.id
                     });
                     newUser.userid = doc.id;
                     localStorage.setItem("user", JSON.stringify(newUser));
                });
                 window.location.href = "/job-list";

            } else {
                // Login
                const userCredential = await signInWithEmailAndPassword(auth, email, password);
                const userAuth = userCredential.user;

                // Fetch user from Firestore
                const myCollection = collection(db, 'wpm_users');
                const q = query(myCollection, where("email", "==", email));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const userDoc = querySnapshot.docs[0];
                    const userData = userDoc.data();
                    // Ensure userid is set (it should be)
                    if (!userData.userid) {
                         userData.userid = userDoc.id;
                    }
                    localStorage.setItem("user", JSON.stringify(userData));
                    window.location.href = "/job-list";
                } else {
                    // User in Auth but not in Firestore? (Should happen only if created outside this flow)
                    // Create it?
                     const newUser = {
                        userid: "",
                        name: email.split('@')[0],
                        email: email,
                        picture: "",
                        datainsert: Date.now(),
                        creditsprompts: 10,
                        creditsimages: 12
                    };
                    await addDoc(myCollection, newUser).then(async (doc) => {
                        await updateDoc(doc, { userid: doc.id });
                        newUser.userid = doc.id;
                        localStorage.setItem("user", JSON.stringify(newUser));
                    });
                    window.location.href = "/job-list";
                }
            }
        } catch (err) {
            console.error(err);
            setError(err.message);
        }
    };


    return (
        <>
            <div className="section-full site-bg-white">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-8 col-lg-6 col-md-5 twm-log-reg-media-wrap">
                            <div className="twm-log-reg-media">
                                <div className="twm-l-media">
                                    <JobZImage src="images/login-bg.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-7">
                            <div className="twm-log-reg-form-wrap">
                                <div className="twm-log-reg-inner">
                                    <div className="twm-log-reg-head">
                                        <div className="twm-log-reg-logo-head">
                                            <span className="log-reg-form-title">{isSignUp ? 'Sign Up' : 'Log In'}</span>
                                        </div>
                                    </div>
                                    <div className="twm-log-reg-form" style={{ display: 'block', width: '100%' }}>

                                        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center', minHeight: '50px' }}>
                                            <GoogleOAuthProvider clientId="306947882627-g9vj62ui865r1tp5d8dv670096bnnncn.apps.googleusercontent.com">
                                                <GoogleLogin
                                                    onSuccess={async credentialResponse => {
                                                        const cred = jwtDecode(credentialResponse.credential);
                                                        let user = {
                                                            userid: "",
                                                            name: cred.name,
                                                            email: cred.email,
                                                            picture: cred.picture,
                                                            datainsert: Date.now(),
                                                            creditsprompts: 10,
                                                            creditsimages: 12
                                                        }
                                                        const myCollection = collection(db, 'wpm_users');
                                                        const q = query(myCollection, where("email", "==", user.email));
                                                        const userexists = await getDocs(q);

                                                        let totaluser = userexists.docs.length

                                                        if (totaluser < 1) {
                                                            await addDoc(myCollection, user).then(async (doc) => {
                                                                await updateDoc(doc, {
                                                                    userid: doc.id
                                                                });

                                                                user.userid = doc.id

                                                                localStorage.setItem("user", JSON.stringify(user))

                                                            })
                                                        }
                                                        else {

                                                            user.userid = userexists.docs[0].id
                                                            localStorage.setItem("user", JSON.stringify(user))
                                                        }


                                                        window.location.href = "/job-list"


                                                    }


                                                    }
                                                    onError={() => {
                                                        console.log('Login Failed');
                                                    }}

                                                />
                                            </GoogleOAuthProvider>
                                        </div>

                                        <div className="text-center" style={{ margin: '20px 0' }}>
                                            <span>OR</span>
                                        </div>

                                        <form onSubmit={handleEmailAuth} style={{ textAlign: 'left' }}>
                                            <div className="form-group mb-3">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    placeholder="Password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            {error && <div className="alert alert-danger">{error}</div>}

                                            <div className="form-group mb-3">
                                                <button type="submit" className="site-button w-100">
                                                    {isSignUp ? 'Sign Up' : 'Log In'}
                                                </button>
                                            </div>
                                        </form>

                                        <div className="text-center mt-3">
                                            <button
                                                className="btn btn-link"
                                                onClick={() => setIsSignUp(!isSignUp)}
                                                style={{ textDecoration: 'none' }}
                                            >
                                                {isSignUp ? 'Already have an account? Log In' : 'Don\'t have an account? Sign Up'}
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginPage;